import { CleanData }     from '../../lib/types';
import { CSSTransition } from 'react-transition-group';
import AnimatedText      from '../AnimatedText';
import BarChart          from './BarChart';
import CornerIcon        from './CornerIcon';

interface Props {
  data: CleanData;
  prev_year_data: CleanData | null;
  main_progress: number;
  current_year: number;
};

export const MusDisplay: React.FC<Props> = ({ data, main_progress, current_year }) => {
  const partial_progress = main_progress % 100;
  const num_chars = Math.min(data.op_chars.length, 5);

  return (<>
    <CSSTransition
      in={partial_progress <= 90}
      timeout={500}
      classNames="slideanimation"
      unmountOnExit
    >
      <div className="flex flex-col relative w-full h-full"
        style={{transition: "all 0.5s ease"}}
      >
        <div style={{marginBottom: '6.5em'}}></div>
        <AnimatedText content={"And who did you fight?"} inProp={partial_progress >= 5} />
        <AnimatedText
          content={<span>Here are your {current_year}'s most common matchups:</span>}
          inProp={partial_progress >= 15}
        />
        <div style={{marginBottom: '2.5em'}}></div>
        {partial_progress >= 25 && (<BarChart data={data.op_chars.slice(0, num_chars)}/>)}
        <CornerIcon char_name={data.op_chars[0].name}/>
      </div>
    </CSSTransition>
  </>);
};
